///////////////////////////////////////////////
//           Match data interfaces           //
///////////////////////////////////////////////
const CompetitionSportsType = {
    FOOTBALL: 'FOOTBALL',
    FUTSAL: 'FUTSAL',
};
const EventType = {
    ASSIST: 'ASSIST',
    ATTACK: 'ATTACK',
    CHANGE_PHASE: 'CHANGE_PHASE',
    CORNER: 'CORNER',
    DISALLOWED_GOAL: 'DISALLOWED_GOAL',
    DROPPED_BALL: 'DROPPED_BALL',
    END_PHASE: 'END_PHASE',
    EXTRA_TIME: 'EXTRA_TIME',
    FAST_ACTION: 'FAST_ACTION',
    FAST_ATTACK: 'FAST_ATTACK',
    FOUL: 'FOUL',
    FREE_KICK: 'FREE_KICK',
    GOAL: 'GOAL',
    GOAL_OPPORTUNITY: 'GOAL_OPPORTUNITY',
    INJURY_TIME: 'INJURY_TIME',
    KICK_OFF: 'KICK_OFF',
    LOST_BALL: 'LOST_BALL',
    OFFSIDE: 'OFFSIDE',
    ORGANIZED_ATTACK: 'ORGANIZED_ATTACK',
    PASS: 'PASS',
    PAUSE: 'PAUSE',
    PENALTY: 'PENALTY',
    RECOVERED_BALL: 'RECOVERED_BALL',
    RED_CARD: 'RED_CARD',
    RED_YELLOW_CARD: 'RED_YELLOW_CARD',
    RESUME: 'RESUME',
    SAVE: 'SAVE',
    SHOT_BLOCKED: 'SHOT_BLOCKED',
    SHOT_ON_GOAL: 'SHOT_ON_GOAL',
    SHOT_WIDE: 'SHOT_WIDE',
    SOLO_RUN: 'SOLO_RUN',
    START_PHASE: 'START_PHASE',
    SUBSTITUTION: 'SUBSTITUTION',
    TACKLE: 'TACKLE',
    THROW_IN: 'THROW_IN',
    VAR: 'VAR',
    VAR_CHECK: 'VAR_CHECK',
    WARNING: 'WARNING',
    YELLOW_CARD: 'YELLOW_CARD',
};
const EventSubType = {
    PENALTY_SECOND_MARK: 'PENALTY_SECOND_MARK',
    OWN: 'OWN',
    PENALTY: 'PENALTY',
    MISSED: 'MISSED',
    SCORED: 'SCORED',
    BAR: 'BAR',
    POST: 'POST',
    HANDBALL: 'HANDBALL',
    SIMULATION: 'SIMULATION',
    FULL_TIME: 'FULL_TIME',
    PAUSED: 'PAUSED',
    SUSPENDED: 'SUSPENDED',
    TIMEOUT: 'TIMEOUT',
    FOUL_PLAY: 'FOUL_PLAY',
    ROUGH_PLAY: 'ROUGH_PLAY',
    TRIP_OPPONENT: 'TRIP_OPPONENT',
    FOUL_PLAYROUGH_PLAY: 'FOUL_PLAYROUGH_PLAY',
    DANGEROUS_PLAY: 'DANGEROUS_PLAY',
    TIME_WASTING: 'TIME_WASTING',
    KICKING_BALL_AWAY: 'KICKING_BALL_AWAY',
    HOLDING_OPPONENT: 'HOLDING_OPPONENT',
    IMPROPER_CONDUCT: 'IMPROPER_CONDUCT',
    DISSENT: 'DISSENT',
    PUSHING_OPPONENT: 'PUSHING_OPPONENT',
    FREE_KICK_DISTANCE: 'FREE_KICK_DISTANCE',
    CHARGING_OPPONENT: 'CHARGING_OPPONENT',
    VIOLENT_PLAY: 'VIOLENT_PLAY',
    ENTERING_WITHOUT_PERMISSION: 'ENTERING_WITHOUT_PERMISSION',
    DIRECT_FREE_KICK: 'DIRECT_FREE_KICK',
    INDIRECT_FREE_KICK: 'INDIRECT_FREE_KICK',
    GOALKEEPER: 'GOALKEEPER',
    FREE_KICK: 'FREE_KICK',
    CORNER: 'CORNER',
    CROSS: 'CROSS',
    FAST_ATTACK: 'FAST_ATTACK',
    WOODWORK: 'WOODWORK',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
    CAUSING_GOAL: 'CAUSING_GOAL',
    HALF_TIME: 'HALF_TIME',
    SAVED: 'SAVED',
    CROSSBAR: 'CROSSBAR',
    WIDE: 'WIDE',
    GOAL_KICK: 'GOAL_KICK',
    LONG: 'LONG',
    MEDIUM: 'MEDIUM',
    CLEARANCE: 'CLEARANCE',
    SHORT: 'SHORT',
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
    CENTER: 'CENTER',
};
const HomeAwayTeam = {
    HOME: 'home',
    AWAY: 'away',
};
const LineupStatus = {
    AVAILABLE: 'AVAILABLE',
    NOT_AVAILABLE: 'NOT_AVAILABLE',
    TACTICAL_AVAILABLE: 'TACTICAL_AVAILABLE',
};
const MatchDayType = {
    FINAL: 'FINAL',
    FIRST_LEG: 'FIRST_LEG',
    MATCHDAY: 'MATCHDAY',
    SECOND_LEG: 'SECOND_LEG',
    UNKNOWN: 'UNKNOWN',
};
const MatchPersonRole = {
    ADDITIONAL_ASSISTANT_REFEREE_ONE: 'ADDITIONAL_ASSISTANT_REFEREE_ONE',
    ADDITIONAL_ASSISTANT_REFEREE_TWO: 'ADDITIONAL_ASSISTANT_REFEREE_TWO',
    ASSISTANT_COACH: 'ASSISTANT_COACH',
    ASSISTANT_REFEREE_ONE: 'ASSISTANT_REFEREE_ONE',
    ASSISTANT_REFEREE_TWO: 'ASSISTANT_REFEREE_TWO',
    ASSISTANT_VIDEO_ASSISTANT_REFEREE: 'ASSISTANT_VIDEO_ASSISTANT_REFEREE',
    ASSISTANT_VIDEO_ASSISTANT_REFEREE_ONE: 'ASSISTANT_VIDEO_ASSISTANT_REFEREE_ONE',
    ASSISTANT_VIDEO_ASSISTANT_REFEREE_THREE: 'ASSISTANT_VIDEO_ASSISTANT_REFEREE_THREE',
    ASSISTANT_VIDEO_ASSISTANT_REFEREE_TWO: 'ASSISTANT_VIDEO_ASSISTANT_REFEREE_TWO',
    COACH: 'COACH',
    FOURTH_OFFICIAL: 'FOURTH_OFFICIAL',
    REFEREE: 'REFEREE',
    REFEREE_OBSERVER: 'REFEREE_OBSERVER',
    REFEREE_ONE: 'REFEREE_ONE',
    REFEREE_THREE: 'REFEREE_THREE',
    REFEREE_TWO: 'REFEREE_TWO',
    TIMEKEEPER: 'TIMEKEEPER',
    UEFA_DELEGATE: 'UEFA_DELEGATE',
    VIDEO_ASSISTANT_REFEREE: 'VIDEO_ASSISTANT_REFEREE',
};
const MatchPhase = {
    END_EXTRA_TIME_SECOND_HALF: 'END_EXTRA_TIME_SECOND_HALF',
    END_SECOND_HALF: 'END_SECOND_HALF',
    EXTRA_TIME_BREAK: 'EXTRA_TIME_BREAK',
    EXTRA_TIME_FIRST_HALF: 'EXTRA_TIME_FIRST_HALF',
    EXTRA_TIME_SECOND_HALF: 'EXTRA_TIME_SECOND_HALF',
    FIRST_HALF: 'FIRST_HALF',
    FULL_TIME: 'FULL_TIME',
    HALF_TIME_BREAK: 'HALF_TIME_BREAK',
    PAUSE: 'PAUSE',
    PENALTY: 'PENALTY',
    PRE_MATCH: 'PRE_MATCH',
    SECOND_HALF: 'SECOND_HALF',
};
const MatchStatus = {
    ABANDONED: 'ABANDONED',
    CANCELED: 'CANCELED',
    FINISHED: 'FINISHED',
    LIVE: 'LIVE',
    POSTPONED: 'POSTPONED',
    SUSPENDED: 'SUSPENDED',
    UNKNOWN: 'UNKNOWN',
    UPCOMING: 'UPCOMING',
};
const MatchType = {
    FIRST_LEG: 'FIRST_LEG',
    GROUP_STAGE: 'GROUP_STAGE',
    REPLAY: 'REPLAY',
    SECOND_LEG: 'SECOND_LEG',
    SINGLE: 'SINGLE',
};
const MatchWinner = {
    HOME: 'HOME',
    AWAY: 'AWAY',
    DRAW: 'DRAW',
};
const PlayerEventSubType = {
    // PENALTIES
    MISSED: 'MISSED',
    // GOALS & PENALTIES
    SCORED: 'SCORED',
    // GOALS
    OWN: 'OWN',
    PENALTY: 'PENALTY',
    FULL_TIME: 'FULL_TIME',
    PENALTY_SECOND_MARK: 'PENALTY_SECOND_MARK',
    // Only for match service <v5
    // PENALTIES
    GOAL: 'GOAL',
    MISS: 'MISS',
    // GOALS
    OWN_GOAL: 'OWN_GOAL',
    PENALTY_GOAL: 'PENALTY_GOAL',
};
const RoundMode = {
    FINAL: 'FINAL',
    GROUP: 'GROUP',
    KNOCK_OUT: 'KNOCK_OUT',
    OTHER: 'OTHER',
};
const RoundPhase = {
    PREQUALIFYING: 'PREQUALIFYING',
    QUALIFYING: 'QUALIFYING',
    TOURNAMENT: 'TOURNAMENT',
};
const RoundStatus = {
    CURRENT: 'CURRENT',
    FINISHED: 'FINISHED',
    UPCOMING: 'UPCOMING',
};
const TeamType = {
    DOMESTIC: 'DOMESTIC',
    NATIONAL: 'NATIONAL',
    OTHER: 'OTHER',
    PLACEHOLDER: 'PLACEHOLDER',
};
const TeamCategory = {
    NATIONAL: 'NATIONAL',
    CLUB: 'CLUB',
};
const WinnerReason = {
    DRAW: 'DRAW',
    WIN_BY_FORFEIT: 'WIN_BY_FORFEIT',
    WIN_ON_AGGREGATE: 'WIN_ON_AGGREGATE',
    WIN_ON_AWAY_GOAL: 'WIN_ON_AWAY_GOAL',
    WIN_ON_EXTRA_TIME: 'WIN_ON_EXTRA_TIME',
    WIN_ON_GOLDEN_GOAL: 'WIN_ON_GOLDEN_GOAL',
    WIN_ON_PENALTIES: 'WIN_ON_PENALTIES',
    WIN_ON_SILVER_GOAL: 'WIN_ON_SILVER_GOAL',
    WIN_ON_TOSS_OF_COIN: 'WIN_ON_TOSS_OF_COIN',
    WIN_REGULAR: 'WIN_REGULAR',
};
const MatchUnitSize = {
    XL: 'xl',
    L: 'l',
    L_PLUS: 'l-plus',
    M: 'm',
    S: 's',
    S_PLUS: 's-plus',
};

export { CompetitionSportsType as C, EventType as E, HomeAwayTeam as H, LineupStatus as L, MatchDayType as M, PlayerEventSubType as P, RoundMode as R, TeamType as T, WinnerReason as W, EventSubType as a, MatchPersonRole as b, MatchPhase as c, MatchStatus as d, MatchType as e, MatchWinner as f, RoundPhase as g, RoundStatus as h, TeamCategory as i, MatchUnitSize as j };

//# sourceMappingURL=match-unit-264e7ba8.js.map